import { QueryResolvers, VirtualObjectType } from '@spazious/dollhouse-graphql';

import { ApolloContext } from '../context.js';
import { getDecorations, getFurnitures } from '../helpers/index.js';

/**
 * Resolver for the virtualObjects query.
 */
export const virtualObjects: QueryResolvers<ApolloContext>['virtualObjects'] = async (
  _,
  variables,
  context
) => {
  const { spaceId } = variables;
  const { api } = context;

  return [
    ...(!variables.type || variables.type === VirtualObjectType.Furniture
      ? await getFurnitures(api, spaceId)
      : []),
    ...(!variables.type || variables.type === VirtualObjectType.Decoration
      ? await getDecorations(api, spaceId)
      : []),
  ];
};
